import { queryOptions, useQuery } from '@tanstack/react-query'

import { userApi } from '../api/userApi'

const getUserConversationQueryOptions = (userId?: number) =>
  queryOptions({
    queryKey: ['user', userId, 'conversation'],
    // oxlint-disable-next-line @typescript-eslint/no-non-null-assertion -- the query is only enabled when userId is defined
    queryFn: ({ signal }) => userApi.getConversationWithUser(userId!, { signal }),
    enabled: !!userId,
  })

export const useUserConversationQuery = (userId?: number) => useQuery(getUserConversationQueryOptions(userId))
